export function isDocumentMessage(message = {}) {
  return /document/i.test(String(message.tipo || message.type || ''))
    || !!message.document || !!message.documentMessage || !!message.documentFileName || !!message.documentUrl;
}

export function documentAttachmentDetails(message = {}, resolvedSrc) {
  const document = message.document || message.documentMessage;
  const nested = typeof document === 'object' && document ? document : {};
  const fileName = [message.documentFileName, message.fileName, message.filename,
    nested.fileName, nested.filename, nested.title, message.title]
    .find(value => typeof value === 'string' && value.trim())?.trim() || 'Documento';
  const rawSrc = resolvedSrc || message.url || message.documentUrl || nested.documentUrl || nested.url
    || (typeof document === 'string' ? document : null);
  // Documents must never open javascript:, data: HTML, protocol-relative URLs
  // or a placeholder "#". Permanent media remains on the authenticated route.
  const safeSrc = typeof rawSrc === 'string'
    && (/^https?:\/\/[^\s]+$/i.test(rawSrc) || /^\/api\/(?:media-storage|media)\?[^#\s]+$/.test(rawSrc))
    ? rawSrc : null;
  let href = safeSrc;
  if (href?.startsWith('/api/media-storage?')) {
    const params = new URLSearchParams(href.slice(href.indexOf('?') + 1));
    params.set('fileName', fileName);
    href = `/api/media-storage?${params}`;
  }
  const temporary = message.mediaRetentionPending === true
    || !(message.mediaPermanent === true && message.storagePath && message.storageProvider === 'replit');
  return { fileName, href, temporary };
}
